import React, { Component } from "react";
import BreadcrumbCustomer from "../breadcrumb";
import {  Form, Input, Button,message,Select} from 'antd';
import storage from '../../utils/storage';
import { configs } from '../../config/config';
 import {dbFields}  from '../../model/user/column';
import { route } from "../../routes/routes";
import { CreateUser } from "../../model/user/requests";
import { getGroupListWithParent } from "../../model/group/requests";

const Option = Select.Option


export const layout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 10,
    },
};

export const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
};

class UserCreate extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            isLogin: false,
            data:{
                email:"",
                passwd:""
            },
            groupList:[]
        }
    };

    handlerSubmit = (e) => {

     let   email = this.formRef.current.getFieldValue(dbFields.email.key);
     let   passwd  = this.formRef.current.getFieldValue(dbFields.passwd.key);
     let  group_id = this.formRef.current.getFieldValue(dbFields.group.key)
     let  desc = this.formRef.current.getFieldValue(dbFields.desc.key)
     if(group_id === "" || group_id === 0 ){
        message.error("Please Chosen A Group")
        return false
     }
     
     let data = {}
     data.email = email
     data.passwd = passwd
     data.group_id = group_id
     data.desc = desc
        // this.state.data.email = email;
        // this.state.data.passwd = passwd;
        CreateUser(data).then(res=>{
            if (res.data.code === 200) {
                message.success("create user successd!")
                setTimeout(()=>{
                    this.props.history.push(route.user.index)
                },1000)
               
            }else{
                message.warn(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })

    }
    // 
    componentDidMount(){
        let groupList = []
        getGroupListWithParent().then(res=>{
            if (res.data.code === 200) {
                groupList = res.data.data
                this.setState({
                    groupList:groupList
                })
            }
        }).catch(err=>{
            message.error(err)
        })
        
    }

    // handlerChange = (item) =>{
    //     console.log(item)
    // }

    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }

    render() {
        const { data,groupList } = this.state;
        return (
            <>
                <BreadcrumbCustomer first='User' second='Create' />
                <Form
                     {...layout}
                    ref={this.formRef}
                    onFinish={this.handlerSubmit}
                    initialValues={{
                        type:1
                    }}
                >
                    <Form.Item label={dbFields.email.title} name={dbFields.email.key}
                       rules={[
                        {
                            required: true,
                        },
                      ]}
                    >
                        <Input  />
                    </Form.Item>
                    <Form.Item label={dbFields.group.title} name={dbFields.group.key}
                       rules={[
                        {
                            required: true,
                        },
                      ]}
                    >
                        <Select 
                            showSearch
                         //   onChange={this.handlerChange}
                        >
                            {groupList.length > 0  && groupList.map((items) => {
                                return (<Option key={items.id} value={items.id}> {items.name} </Option>)
                            })}
                        </Select>
                    </Form.Item>
                            
                    <Form.Item label={dbFields.passwd.title} name={dbFields.passwd.key}
                       rules={[
                        {
                            required: true,
                        },
                      ]}
                    >
                        <Input.Password  />
                    </Form.Item>

                    <Form.Item
                            name= {dbFields.desc.key}
                            label={dbFields.desc.title}
                    
                        >
                            <Input.TextArea />
                        </Form.Item>
                    <Form.Item {...tailLayout}>
                        <Button type="primary"  style={{background: "#851dd6",color:"white" }} htmlType="submit" >Create</Button>
                    </Form.Item>
                </Form>  
            </>
        );
    }
}

export default UserCreate;